var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.8793 38.5871V26.743H73.0352L55.7262 0L38.354 26.743H26.5267V38.5871L0.38208 56.0688L26.531 73.1587V85.0829H38.354L55.7051 111.83L73.031 85.0829H84.8751V73.1587L111.799 56.0688L84.8793 38.5871ZM55.7262 7.68118L73.0352 34.6053L55.6967 51.9438L38.3371 34.6053L55.7262 7.68118ZM7.47759 55.8539L34.4017 38.5449L51.7402 55.8834L34.4017 73.243L7.47759 55.8539ZM55.7304 104.107L38.3414 77.1826L55.7009 59.8441L73.0394 77.1826L55.7304 104.107ZM76.979 73.243L59.6405 55.8834L76.979 38.5449L103.903 55.8539L76.979 73.243Z",
    fill: "url(#paint0_radial_726_50218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7134 17.0098L44.3455 34.6137L55.6924 45.948L67.0308 34.6137L55.7134 17.0098Z",
    fill: "url(#paint1_linear_726_50218)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3455 77.1744L55.7134 94.7741L67.0308 77.1744L55.6924 65.8359L44.3455 77.1744Z",
    fill: "url(#paint2_linear_726_50218)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4101 44.5488L16.8062 55.8662L34.4101 67.2342L45.7444 55.8873L34.4101 44.5488Z",
    fill: "url(#paint3_linear_726_50218)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9663 44.5488L65.6321 55.8873L76.9663 67.2342L94.5703 55.8662L76.9663 44.5488Z",
    fill: "url(#paint4_linear_726_50218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_726_50218",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0885 55.9171) scale(55.8118 55.8118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#701C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422F8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_726_50218",
    x1: 55.6882,
    y1: 44.7977,
    x2: 55.6882,
    y2: 18.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#701C61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_726_50218",
    x1: 55.5787,
    y1: 65.7306,
    x2: 55.6882,
    y2: 94.2769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#701C61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_726_50218",
    x1: 15.5168,
    y1: 55.8915,
    x2: 44.455,
    y2: 55.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#701C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422F8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_726_50218",
    x1: 65.6321,
    y1: 55.8915,
    x2: 94.5703,
    y2: 55.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#701C61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGradient);
export default __webpack_public_path__ + "static/media/logo-gradient.076ea39d7f37384a53782257852cbf32.svg";
export { ForwardRef as ReactComponent };